/**
 * This function obfuscates an email address
 * @param email 
 * @returns a string with the obfuscated email address that looks like 
 * `x****@gmail.com`. The `*` will be equal to the number of characters in the
 * original email address
 */
export function obfuscateEmail(email: string): string {
  const [localPart, domain] = email.split("@");
  if (!localPart || !domain) return email; // Return as-is if it's not a valid email

  const obfuscatedLocal = `${localPart[0]}${"*".repeat(localPart.length - 1)}`;
  return `${obfuscatedLocal}@${domain}`;
}
